// Copyright (c) 2024 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export enum Theme {
    Light = 'light',
    Dark = 'dark',
    Names = 'names',
}

export enum ThemePreference {
    Light = 'light',
    Dark = 'dark',
    Names = 'names',
    System = 'system',
}
